import { Button, Container, CssBaseline, makeStyles, TextField, Typography, Input, InputAdornment, InputLabel, IconButton, FormControl, Grid, List, ListItem, Box } from '@material-ui/core';
import { COLORS } from '../../shared/Theme';

import React, { Fragment, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';
import { SIcon } from '../../shared/Icon';

import axios from 'axios';
import { admin as v_admin, basic, Values, SNACKBAR_TIME, material } from '../../request/values';
import { useCookies } from 'react-cookie';
import { SubAdminHeaderBar } from '../../shared/header/HeaderBar';

//const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	content: {
		width: '100%',
		height: '100%',
		display: 'grid',
		//gridTemplateColumns: '230px 1fr',
	},
	mainPage: {
		display: 'grid',
		gridTemplateRows: '1.5fr 5fr',
	},
	title: {
		margin: '5vh 0px 0px 35px',
		fontFamily: 'NanumR',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		display: 'flex',
		gap: '10vw',
	},
	logo: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'stretch',
		//border: 'solid white',
		margin: '5vh 0px',
		borderWidth: '0px 0px 1px 0px',
		//cursor: 'pointer',
		'& img': {
			width: '30px',
			maxHeight: '50%',
			height: '30px',
			margin: '12px 5px 0px 9%',
		},
		'& #name': {
			display: 'inline-block',
			margin: '10px 0px 0px 0px',
			width: 'calc(91% - 35px)',
			fontFamily: 'NanumR',
			fontSize: '1.5rem',
			fontWeight: 'bolder',
		},
		'& #welcome': {
			display: 'block',
			margin: '5px 0px 0px 9%',
			fontFamily: 'NanumR',
			fontSize: '1.2rem',
		},
	},
	userinfo: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		border: 'none',
		borderWidth: '0px 0px 1px 0px',
		paddingBottom: '0.5vh',
		'& #name': {
			display: 'inline-block',
			fontFamily: 'NanumR',
			fontSize: '1.25rem',
			fontWeight: 'bolder',
		},
	},
	menu: {
		display: 'grid',
		border: 'none',
		borderWidth: '0px 0px 1px 0px',
		fontFamily: 'NanumR',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		'&::after': {
			content: '""',
			position: 'absolute',
			width: '0',
			height: '0',
			left: '50%',
			bottom: '0',
			borderBottom: '3px solid black',
			transition: 'width 0.3s ease, left 0.3s ease',
			WebkitTransition: 'width 0.3s ease, left 0.3s ease',
		},
		'&:hover::after': {
			width: '100%',
			left: '0',
		},
		'&:hover': {
			backgroundColor: 'transparent', // hover 배경색 제거
		},
	},
	navigator: {
		display: 'grid',
		gridTemplateColumns: '1fr 2fr',
		marginTop: '1%',
		//fontSize: '5vw',
		//backgroundColor: `${COLORS.WHITE}`,
	},
	subTitle: {
		minWidth: '10vw',
		display: 'flex',
		flexDirection: 'column',
	},
	menuOpen: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		alignItems: 'center',
		marginTop: '10px',
		gap: '10px',
		'& a': {
			margin: '5px',
			fontSize: '1rem',
			width: 'fit-content',
			height: '100%',
			cursor: 'pointer',
			textAlign: 'center',
			position: 'relative',
			'&::after': {
				content: '""',
				position: 'absolute',
				display: 'inline-block',
				width: '0',
				height: '0',
				left: '50%',
				bottom: '-5px',
				borderBottom: '2px solid black',
				transition: 'width 0.3s ease, left 0.3s ease',
				WebkitTransition: 'width 0.3s ease, left 0.3s ease',
			},
			'&:hover::after': {
				width: '100%',
				left: '0',
			},
		},
	},
	menuClose: {
		display: 'none',
	},
	form: {
		display: 'flex',
		width: '97%',
		height: '5%',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '1%',
		'& input': {
			width: '30%',
			height: '80%',
			paddingLeft: '7px',
		},
		'& Button': {
			//border: 'solid 1px',
			border: 'solid gray 1px',
			height: '90%',
			//borderStyle: 'inset',
			//backgroundColor: '-webkit-control-background',
		},
	},
	submit: {},
	classList: {
		'& #classOpen': {
			float: 'right',
			margin: '5px 3%',
			padding: '5px 25px',
			color: `${COLORS.WHITE}`,
			borderRadius: '5px',
			backgroundColor: `${COLORS.WATER_BLUE}`,
			'&:hover': {
				color: `${COLORS.WATER_BLUE}`,
				backgroundColor: 'inherit',
			},
		},
		'& #logout': {
			float: 'left',
			margin: '5px 3%',
			padding: '5px 25px',
			color: `${COLORS.WHITE}`,
			borderRadius: '5px',
			backgroundColor: `${COLORS.WATER_BLUE}`,
			'&:hover': {
				color: `${COLORS.WATER_BLUE}`,
				backgroundColor: 'inherit',
			},
		},
	},
	table: {
		display: 'grid',
		gridTemplateRows: '50px 1fr',
		width: '94%',
		height: '60vh',
		margin: '1% 3%',
		//border: 'none',
		//borderRadius: '10px 10px 0 10px',
		'& #title': {
			display: 'grid',
			gridTemplateColumns: '3fr 4fr 3fr 4fr',
			border: 'solid',
			borderWidth: '0 0 2px 0',
			//background: 'none',
			'& span': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				'& p': {
					fontSize: '1.15rem',
					fontWeight: 'bolder',
				},
			},
		},
		'& #classinfo': {
			overflow: 'scroll',
			overflowX: 'hidden',
			borderRadius: '0 0 0 10px',
		},
		'& ul': {
			padding: '0',
		},
		'& li': {
			border: 'solid gray',
			borderWidth: '0 0 1px 0',
		},
	},
	classInfo: {
		display: 'grid',
		gridTemplateColumns: '3fr 4fr 3fr 4fr',
		padding: '25px 0',
		//backgroundColor: `${COLORS.LIGHT_GREY}`,
		backgroundColor: `${COLORS.WHITE}`,
	},
	buttonLabel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: 'none',
		fontSize: '1rem',
		fontFamily: 'NanumB',
		//fontWeight: 'bold',
		lineHeight: '21px',
		bolderWidth: '1px',
	},
	blank: {
		display: 'flex',
		height: '40px',
	},
}));

type iClassList = {
	class_name: string;
	company_name: string;
	capital: string;
	reg_date: string;
};

const SERVER = basic.server;

const SubAdminClassInfo: React.FC<any> = (props) => {
	const classes = useStyles();
	let history = useHistory();

	const { member, deleteMember } = props;
	const [cookies, setCookie, removeCookie] = useCookies();
	const [ClassList, setClassList] = useState<iClassList[]>([]);
	const [targetClassName, setTargetClassName] = useState<any | null>();
	const [menu, setMenu] = useState<boolean>(false);
	const [operMenu, setOperMenu] = useState<boolean>(false);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const moveOperList = () => {
		history.push('/subAdminOperList');
	};
	const moveClassList = () => {
		history.push('/subAdminClassList');
	};
	const moveClassManage = () => {
		history.push('/subAdminClassManage');
	};

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { id, value } = e.target;
		if (id == 'targetClassName') setTargetClassName(value);
	};

	const searchControl = () => {
		//        if (targetClassName === '')
		//           enqueueSnackbar(ToastStr.CLASS_COUNTRY_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
		//       else
		searchClassContent();
	};

	const searchClassContent = () => {
		let url = new URL(SERVER + v_admin.admin + v_admin.search_class_info);
		let params = {
			id: member.id.toString(),
			targetClassName: targetClassName.toString(),
		};
		url.search = new URLSearchParams(params).toString();
		axios({
			method: 'GET',
			withCredentials: true,
			//url: SERVER + v_admin.admin + v_admin.search_class,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setClassList(data.data);
				}
			});
	};

	return (
		<div className={classes.background}>
			<CssBaseline />
			<div className={classes.content}>
				<div className={classes.mainPage}>
					<SubAdminHeaderBar />
					<div className={classes.classList}>
						<div className={classes.form}>
							<input type="text" placeholder="검색할 지역을 입력해주세요." id="targetClassName" onChange={valueChangeHandler} />
							<Button onClick={searchControl}>
								<Typography>검색</Typography>
							</Button>
						</div>
						<div className={classes.table}>
							<div id="title">
								<span>
									<Typography>클래스 이름</Typography>
								</span>
								<span>
									<Typography>회사명</Typography>
								</span>
								<span>
									<Typography>1등 기업 자산</Typography>
								</span>
								<span>
									<Typography>클래스 등록 날짜</Typography>
								</span>
							</div>
							<List id="classinfo">
								{ClassList != null &&
									ClassList.map((item: any, index: number) => {
										return <AppListItem index={index} code={item.class_name} name={item.company_name} capital={item.capital} date={item.reg_date} />;
									})}
								<div className={classes.blank}></div>
							</List>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const AppListItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { index, code, name, capital, date } = props;

	return (
		<ListItem id={index} className={classes.classInfo}>
			<Box className={classes.buttonLabel}>{code}</Box>
			<Box className={classes.buttonLabel}>{name}</Box>
			<Box className={classes.buttonLabel}>{capital}</Box>
			<Box className={classes.buttonLabel}>{date != null && date.length >= 19 && date.substring(5, 10).replace('-', '/')}</Box>
		</ListItem>
	);
};

export default SubAdminClassInfo;
